
import { call, put, takeEvery } from "redux-saga/effects";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ICaThi } from "../../../model/respone/tct/ICaThi";
import { eCaThiActionIds, ICaThiActionTypes } from "../../action-types/tct/ICaThiActions";
import { rootActions } from "../../actions/rootActions";
import { caThiApi } from "../../../api/tct/caThiApi";
const mainAction = rootActions.toChucThi.caThi;
export function* caThiSaga(): any {
    yield takeEvery(eCaThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eCaThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eCaThiActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ICaThiActionTypes): any {
    const res: IBaseRespone = yield call(caThiApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ICaThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as ICaThi
    if (payload.id > 0) {
        res = yield call(caThiApi.Update, payload)
    } else {
        res = yield call(caThiApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ICaThiActionTypes): any {
    const res: IBaseRespone = yield call(caThiApi.Deletes, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}